import { useTranslation } from "react-i18next";
import { MessageVariant } from "./types";
import { Box, CircularProgress, Typography } from "@mui/material";

type MessageBottomTextType = "sending" | "send";

interface IProps {
  variant: MessageVariant;
  type?: MessageBottomTextType | null;
}

export default function MessageBottomText(props: IProps) {
  const {
    variant,
    type = null,
  } = props;
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: variant === "out" ? "flex-end" : "flex-start",
        gap: 1,
        lineHeight: "10px",
      }}>
        <Typography
          variant={"caption"}
          sx={{
            opacity: 0.6,
          }}
        >{t(type === "sending" ? "sending" : "sent")}</Typography>
        {type === "sending" && (
          <Box>
            <CircularProgress
              size={"10px"}
              color={"inherit"}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}